enum LocalStoragePrefix {
  CollectorSurveyDismissals = "CollectorSurveyDismissals",
  CreatorSurveyDismissals = "CreatorSurveyDismissals",
  Signature = "Signature",
  WalletType = "WalletType",
}

export default LocalStoragePrefix;
